import elements from "../Diagram/newElements.json";
import boiler from "../Diagram/elementsData/boiler.json";
import comments from "../Diagram/elementsData/comments.json";
import container from "../Diagram/elementsData/container.json";
import equipment from "../Diagram/elementsData/equipment.json";
import heatExchanger from "../Diagram/elementsData/heatExchanger.json";
import others from "../Diagram/elementsData/others.json";
import products from "../Diagram/elementsData/products.json";
import pump from "../Diagram/elementsData/pump.json";
import reactor from "../Diagram/elementsData/reactor.json";
import separator from "../Diagram/elementsData/separator.json";
import tank from "../Diagram/elementsData/tank.json";
import tower from "../Diagram/elementsData/tower.json";
import Flash2 from "../Diagram/elementsData/Flash2.json";
import MultiStreamExchanger from "../Diagram/elementsData/MultiStreamExchanger.json";
import Mixer from "../Diagram/elementsData/Mixer.json";
import Group from "../Diagram/elementsData/group.json";
import Link from "../Diagram/elementsData/link.json";


//构建元件类型参数索引表
export const buildNodeTypeParamsForm = () => 
{
    let nodeTypeParamsForm = {};
    
    const typeIdExtraElementsParams = 
    {
      boiler:boiler,
      comments:comments,
      container:container,
      equipment:equipment,
      ShellAndTubeExchanger:heatExchanger,
      others:others,
      products:products,
      pump:pump,
      reactor:reactor,
      Splitter:separator,
      tank:tank,
      DistilStrict:tower,
      Flash2:Flash2,
      Mixer:Mixer,
      MultiStreamExchanger:MultiStreamExchanger,
      group:Group,
      link:Link
    };

    for(let i=0;i<elements.length;i++)
    {
        let element = elements[i];
        let typeId = element.typeID;
        let publicParams = element.params;

        let newParams = {};
        for(let j=0;j<publicParams.length;j++)
        {
            let publicParam = publicParams[j];
            let p_engName = publicParam.p_engName;
            newParams[p_engName] = publicParam;
        }

        let extraElementDatas = typeIdExtraElementsParams[typeId];
        if(extraElementDatas)
        {
            for(let j=0;j<extraElementDatas.length;j++)
            {
                let extraElementData = extraElementDatas[j];
                let elementName = extraElementData.nodeName;
                let extraParams = extraElementData.params;

                let newExtraParams = {};
                for(let k=0;k<extraParams.length;k++)
                {
                    let extraParam = extraParams[k];
                    let p_engName = extraParam.p_engName;
                    newExtraParams[p_engName] = extraParam;
                }

                let allParams = {...newParams,...newExtraParams};

                nodeTypeParamsForm[elementName] = allParams;
            }
        }
    }

    return nodeTypeParamsForm;
};
